import React from "react";
import { useTranslation } from "react-i18next";
import "./PatientDetails.css";

const NotesSection = ({ notes }) => {
  const { t } = useTranslation();

  return (
    <div className="whp-container notes-section">
      <div className="title-hr2">
        <p>{t("description")}</p>
        <hr />
      </div>
      <div className="notes-content">
        <p>{notes || t("noNotesAvailable")}</p>
      </div>
    </div>
  );
};

export default NotesSection;
